import { Component } from "@angular/core";
import { AuthUserDbService } from "@app/auth/services/auth-user-db.service";
import { FirebaseAuthService } from "@app/auth/services/firebase-auth.service";
import { RouterService } from "@app/root-store/router.service";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { FacebookAuthProvider, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { pipe } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

@Component({
    selector: "app-login-interstitial",
    templateUrl: "./login-interstitial.component.html",
    styleUrls: ["./login-interstitial.component.scss"],
})
export class LoginInterstitialComponent {
    loginType$ = this.routerService.findParamFactory("type").pipe(
        filter(type => !!type),
        take(1),
        this.loginPipe()
    );
    spinnerText = "Loading your account";

    constructor(
        private readonly firebaseAuth: FirebaseAuthService,
        private readonly authUserDbService: AuthUserDbService,
        private readonly tsLoggingService: TSLoggingService,
        private readonly routerService: RouterService
    ) {}

    loginPipe() {
        return pipe(
            tap((type: string) => {
                this.tsLoggingService.logNoSessionEventData(null, "user", "ssopgrest", "login", null, { [type]: "login attempt" });
                if (!this.authUserDbService.isPendingLoginState) {
                    if (type === "facebook") {
                        this.authUserDbService.isPendingLoginState = true;
                        this.firebaseAuth.signInWithRedirect(new FacebookAuthProvider()).catch(_ => null);
                    } else if (type === "google") {
                        this.authUserDbService.isPendingLoginState = true;
                        this.firebaseAuth.signInWithRedirect(new GoogleAuthProvider()).catch(_ => null);
                    } else if (type === "apple") {
                        this.authUserDbService.isPendingLoginState = true;
                        this.firebaseAuth.signInWithRedirect(new OAuthProvider("apple.com")).catch(_ => null);
                    }
                }
            })
        );
    }
}
